class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.searchInput = this.querySelector('input[type="search"]');
    this.closeButton = this.querySelector('button[type="button"]');

    // Try to find header in constructor
    const header = document.querySelector("header.main-nav");
    // console.log("Constructor - Found header:", header);
    // if (header) {
    //   console.log("Constructor - Header classes:", header.className);
    // }

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code.toUpperCase() === "ESCAPE" && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    if (this.closeButton) {
      this.closeButton.addEventListener("click", this.close.bind(this));
    }

    if (this.searchInput) {
      this.searchInput.addEventListener("input", this.onInputChange.bind(this));
      this.searchInput.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.close();
      });
    }

    this.summaryToggle.setAttribute("role", "button");
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    console.log(
      "Summary clicked, current open state:",
      event.target.closest("details").hasAttribute("open")
    );
    event.target.closest("details").hasAttribute("open")
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains("modal-overlay")
    )
      this.close(false);
  }

  onInputChange(event) {
    const searchTerm = event.target.value;
    this.dispatchEvent(
      new CustomEvent("search", { detail: { searchTerm }, bubbles: true })
    );
  }

  open(event) {
    console.log("Opening search modal");
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    // document.body.classList.add("overflow-hidden");

    // Try different selectors
    console.log("Trying to find header...");

    // Try first with just main-nav
    let header = document.querySelector("header.main-nav");
    console.log("1. header.main-nav:", header);

    // Try with all classes
    const headerAll = document.querySelector(
      "header.main-nav.white-nav.header"
    );
    console.log("2. header.main-nav.white-nav.header:", headerAll);

    // Try just the header tag
    const allHeaders = document.querySelectorAll("header");
    console.log("3. All headers found:", allHeaders.length);
    Array.from(allHeaders).forEach((h, i) => {
      console.log(`Header ${i} classes:`, h.className);
    });

    // Use the first method as it worked before
    if (header) {
      console.log("Adding search-nav class");
      console.log("Before - Header classes:", header.className);
      header.classList.add("search-nav");
      console.log("After - Header classes:", header.className);
    } else {
      console.log("Header element not found!");
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.searchInput ||
        this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (this.searchInput) {
      requestAnimationFrame(() => {
        this.searchInput.focus();
      });
    }
  }

  close(focusToggle = true) {
    console.log("Closing search modal");
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    // document.body.classList.remove("overflow-hidden");

    const header = document.querySelector("header.main-nav");
    console.log("Found header for closing:", header);
    if (header) {
      console.log("Before removing - Header classes:", header.className);
      header.classList.remove("search-nav");
      console.log("After removing - Header classes:", header.className);
    }
  }
}

customElements.define("search-modal", SearchModal);
